import { queryOptions } from "@tanstack/react-query";
import { apiRequest } from "../../lib/api";
import type { Configuration, ConfigurationChanges, Slot } from "../../lib/api-types";
import { paths } from "../../lib/endpoints";

export const configurationsQuery = (workspaceId: string, deleted: boolean) =>
  queryOptions({
    queryKey: ["configurations", workspaceId, deleted ? "deleted" : "live"] as const,
    queryFn: () => apiRequest<Configuration[]>(paths.configurations(workspaceId, deleted)),
  });

export const configurationQuery = (workspaceId: string, configurationId: string) =>
  queryOptions({
    queryKey: ["configurations", workspaceId, "one", configurationId] as const,
    queryFn: () => apiRequest<Configuration>(paths.configuration(workspaceId, configurationId)),
  });

export const slotsQuery = (workspaceId: string, configurationId: string) =>
  queryOptions({
    queryKey: ["slots", workspaceId, configurationId] as const,
    queryFn: () => apiRequest<Slot[]>(paths.slots(workspaceId, configurationId)),
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
  });

export const changesQuery = (workspaceId: string, configurationId: string) =>
  queryOptions({
    queryKey: ["changes", workspaceId, configurationId] as const,
    queryFn: () =>
      apiRequest<ConfigurationChanges>(paths.configurationChanges(workspaceId, configurationId)),
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
  });
